import { motion } from "framer-motion";
import { Phone, ArrowRight } from "lucide-react";
import { COMPANY, IMAGES } from "@/data/content";

export default function CTABand({ onQuote }) {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.shingles} alt="New roof shingles installed in Snohomish County, WA" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-honey/90 mix-blend-multiply" />
        <div className="absolute inset-0 bg-obsidian/40" />
      </div>
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
        className="relative z-10 max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <h2 className="text-4xl sm:text-6xl font-display font-black uppercase tracking-tighter text-white drop-shadow">
          Your Roof Deserves the Best
        </h2>
        <p className="text-white/90 text-lg mt-5 max-w-2xl mx-auto font-medium">
          Book your free, no-obligation in-home evaluation today. Honest pricing, expert craftsmanship,
          and a 50-year guarantee — that's the HoneyBee promise.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-9">
          <button onClick={onQuote} data-testid="cta-band-quote-btn"
            className="bg-obsidian text-white font-bold px-8 py-4 rounded-sm flex items-center gap-2 hover:bg-black transition-colors w-full sm:w-auto justify-center">
            Get My Free Evaluation <ArrowRight className="w-5 h-5 text-honey" />
          </button>
          <a href={`tel:${COMPANY.phoneRaw}`} data-testid="cta-band-call-btn"
            className="bg-white/15 backdrop-blur border border-white/40 text-white font-bold px-8 py-4 rounded-sm flex items-center gap-2 hover:bg-white/25 transition-colors w-full sm:w-auto justify-center">
            <Phone className="w-5 h-5" /> {COMPANY.phone}
          </a>
        </div>
      </motion.div>
    </section>
  );
}
